__turbopack_context__.v({
  "container": "wTUIJG_container",
  "title": "wTUIJG_title",
});
